import { Component, inject } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import DateFormat from "@bitwarden/web-vault/app/shared/utils/helper.date/date-format";
import {
  ALIGNMENT_BALANCE_RESET,
  REVALUATION,
} from "@bitwarden/web-vault/app/models/constants/global.constants";
import {
  TransactionLinkType,
  TransactionStatus,
} from "@bitwarden/web-vault/app/models/types/transaction.types";
import { RoleAccessService } from "@bitwarden/web-vault/app/services/permission/role-access.service";

@Component({
  selector: "app-transaction-desc-renderer",
  templateUrl: "./transaction-desc-renderer.component.html",
})
export class TransactionDescriptionCellRenderer implements ICellRendererAngularComp {
  private roleAccessService = inject(RoleAccessService);

  description!: string;
  date!: string;
  dateFormat = new DateFormat();
  alignBalReset: string = ALIGNMENT_BALANCE_RESET;
  alignment: string = "Align";
  revaluation: string = REVALUATION;
  status!: TransactionStatus;
  linkType: TransactionLinkType | null = null;

  agInit(params: ICellRendererParams): void {
    this.setData(params);
  }

  setData(params: ICellRendererParams) {
    this.description = params.data.description || "";
    this.date = this.dateFormat.getDateStringFromStamp(params.data.transactionDate) || "";
    this.status = params.data.status;
    this.linkType = this.roleAccessService.isBetaUser()
      ? (params.data.transactionView?.c_linkType ?? null)
      : null;
  }

  refresh(params: ICellRendererParams): boolean {
    this.setData(params);
    return true;
  }
}
